module.exports = __webpack_public_path__ + "static/media/running.9567ede1.png";